import { Button } from "Components/CustomComponents";
import { useBulkUploadMutation } from "Data/services/parserApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { ErrorToast, InfoToast, SuccessToast } from "Hooks/useToast";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { FaCircleXmark, FaDownload } from "react-icons/fa6";
import { FiUploadCloud } from "react-icons/fi";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

interface ParserModalProps {
  // data: null;
  // loading: boolean;
  handleParserModalClose: () => void;
  getRoutes: () => void;
  setUploadLoading: (loading: boolean) => void; // ✅ Use `boolean` primitive
  uploadLoading: boolean; // ✅ Use `boolean` primitive
  // onDelete: (id: number) => void;
}
export interface UploadFormData {
  file: string | null | undefined;
}

const ParserModal: React.FC<ParserModalProps> = ({
  handleParserModalClose,
  getRoutes,
  setUploadLoading,
  uploadLoading,
  // data,
  // onDelete,
  // loading,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [bulkUpload, { isLoading }] = useBulkUploadMutation();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (
      selectedFile &&
      (selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        selectedFile.type === "application/vnd.ms-excel")
    ) {
      setFile(selectedFile);
    } else {
      InfoToast("Please upload a valid Excel file (.xls or .xlsx)");
      setFile(null);
    }
  };
  const handleCreateDriver = async () => {
    if (!file) {
      ErrorToast("No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await bulkUpload(formData).unwrap(); // API call
      if (response.code === 200) {
        SuccessToast(response.message);
        handleParserModalClose();
        getRoutes();
        setUploadLoading(!uploadLoading)
      }
    } catch (error: unknown) {
      ErrorToast(getErrorMessage(error));
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleParserModalClose} dropShadow={false}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 black-text">Upload File</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleParserModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div>
            <div className="upload-container">
              <label className="upload-box">
                <FiUploadCloud size={40} className="upload-icon" />
                <span className="upload-text">
                  Click to upload an Excel file
                </span>
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </label>
              {file && <p className="file-name">Selected: {file.name}</p>}
              <Button
                className="upload-button mt-3"
                text={
                  isLoading ? (
                    <Spinner animation="border" variant="light" size="sm" />
                  ) : (
                    "Upload"
                  )
                }
                disabled={!file}
                onClick={handleCreateDriver}
              />
            </div>
            <div className="download-container d-flex align-items-center justify-content-center">
              <a href="/sample.xlsx" download="sample.csv">
                <Button
                  className="mt-5 download-button download-file-button"
                  text={
                    <div className={"d-flex align-items-center gap-2"}>
                      <FaDownload />
                      Download Sample
                    </div>
                  }
                />
              </a>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ParserModal;
